export default __webpack_public_path__ + "static/media/gitee.00ec4a4d.svg";